import gql from 'graphql-tag';

export const POSITION_CREATE_MUTATION = gql`
  mutation CreatePosition($position: PositionCreateInput) {
    createPosition(position: $position) {
      id
      canEditPosition
      dailyProjectPrompts
      dailyProjectPromptsUseSubprojects
      level
      manageBudgets
      viewBudgets
      manageCompanySettings
      manageCostCodes
      manageEmployeeGroups
      manageEmployees
      manageEquipment
      manageMediaCollection
      manageProjectGroups
      manageProjects
      manageTimeEntries
      memberLock
      organizationId
      requestSignatures
      scopeByGroup
      submittedOn
      timeEvents
      title
      viewAllActivityReport
      viewEquipmentDetails
      viewEquipmentStatus
      viewMemberActivityReport
      viewMemberExpenses
      viewProjectExpenses
      canManageProjectCostCodeQuantity
      updatedOn
      createdOn
      deletedOn
    }
  }
`;

export const POSITION_UPDATE_MUTATION = gql`
  mutation UpdatePosition($position: PositionUpdateInput) {
    updatePosition(position: $position) {
      id
      canEditPosition
      dailyProjectPrompts
      dailyProjectPromptsUseSubprojects
      level
      manageBudgets
      viewBudgets
      manageCompanySettings
      manageCostCodes
      manageEmployeeGroups
      manageEmployees
      manageEquipment
      manageMediaCollection
      manageProjectGroups
      manageProjects
      manageTimeEntries
      memberLock
      organizationId
      requestSignatures
      scopeByGroup
      submittedOn
      timeEvents
      title
      viewAllActivityReport
      viewEquipmentDetails
      viewEquipmentStatus
      viewMemberActivityReport
      viewMemberExpenses
      viewProjectExpenses
      canManageProjectCostCodeQuantity
      updatedOn
      createdOn
      deletedOn
    }
  }
`;
